<template>
<div>
    <div class="card">
        <div class="card-body">
            <h5 class="card-title mb-4">Origin Information</h5>
            <div class="row g-3 mb-2">
                <div class="col-sm-3"><span class="text-muted">LGA of Origin:</span></div>
                <div class="col-sm-7" v-if="item.lga_of_origin">
                        {{ item.lga_of_origin.name }}</div>
            </div>
            <div class="row g-3 mb-2">
                <div class="col-sm-3"><span class="text-muted">Certificate of Origin:</span></div>
                <div class="col-sm-7" > <a :href="absoluteUrl(item.certificate_of_origin)"
                    @click.prevent="showPdfModal()"
                    > Click to view certificate</a></div>
            </div>
        </div>
    </div>
</div>

</template>

<script>
export default {
    props:{
        item:{
            type: Object,
            required: true
        }
    },
    methods: {
        showPdfModal() {
            let filePath = this.absoluteUrl(this.item.certificate_of_origin);
            this.$store.commit('TOGGLE_PDF_MODAL_FRAME', { visible: true, filePath: filePath})
        }
    }
}
</script>

<style></style>